import { CommonModule } from '@angular/common'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { RouterLink } from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'
import { Observable, Subscription, tap } from 'rxjs'

import {
  ActiveSorting,
  TableBaseAbstract,
} from '../../abstracts/table-base.abstract'
import { ButtonComponent } from '../../components/button/button.component'
import { PageHeadlineComponent } from '../../components/page-headline/page-headline.component'
import { SearchBoxComponent } from '../../components/search-box/search-box.component'
import {
  TableComponent,
  TableDataBase,
} from '../../components/table/table.component'
import { UserComponent } from '../../components/user/user.component'
import { TypedTemplateDirective } from '../../directives/typed-template.directive'
import { Snapshot } from '../../models/snapshot.model'
import { HighLightTextPipe } from '../../pipes/high-light-text.pipe'
import { Expression } from '../../repositories/base.repository'
import { SnapshotRepository } from '../../repositories/snapshot/snaphot.repository'

export type TableData = TableDataBase & Snapshot

@Component({
  selector: 'app-snapshots',
  standalone: true,
  imports: [
    CommonModule,
    ButtonComponent,
    PageHeadlineComponent,
    TranslatePipe,
    SearchBoxComponent,
    TableComponent,
    UserComponent,
    HighLightTextPipe,
    RouterLink,
    SvgIconComponent,
    TypedTemplateDirective,
  ],
  templateUrl: './snapshots.component.html',
})
export class SnapshotsComponent
  extends TableBaseAbstract
  implements OnInit, OnDestroy
{
  private subscription!: Subscription

  public typeToken!: { index: number; item: string; currentRow: TableData }

  public override activeSorting: ActiveSorting = [
    {
      key: 'createdAt',
      value: 'descend',
    },
  ]

  public tableData: TableData[] = []

  public constructor(private readonly snapshotRepository: SnapshotRepository) {
    super()
  }

  public onSearchFilterChange(sword: string): void {
    this.sword = sword
    this.pageIndex = 1
    this.updateTableData()
  }

  public download(id: string): void {
    this.snapshotRepository.downloadCSV(id)
  }

  protected getFilter(): Expression<Snapshot>[] {
    const filter: Expression<Snapshot>[] = []

    if (this.sword) {
      filter.push(
        this.snapshotRepository.getSearchQuery(this.sword, [
          'createdBy',
          'name',
          'note',
        ])
      )
    }

    return filter
  }

  protected fetchTableData(): Observable<unknown> {
    return this.snapshotRepository
      .list({
        limit: this.pageSize,
        page: this.pageIndex,
        filter: this.getFilter(),
        sorting: this.getSorting(),
      })
      .pipe(
        tap((response) => {
          this.total = response.meta.totalCount
          this.tableData = response.data.map((res) => ({
            ...res.attributes,
            id: res.id,
          }))
          this.isLoading = false
        })
      )
  }

  public ngOnInit(): void {
    this.updateTableData()
  }

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe()
  }

  protected updateTableData(): void {
    this.isLoading = true
    this.subscription = this.fetchTableData().subscribe()
  }
}
